export default __webpack_public_path__ + "static/media/level-10-bg.bb12faa4.png";